import GrupoMMParticular1 from './GrupoMMParticular1';
import GrupoMMParticular2 from './GrupoMMParticular2';

export default {
    GrupoMMParticular1,
    GrupoMMParticular2,
};